import { Link } from "react-router";
import { format } from "date-fns";
import { da } from "date-fns/locale";
import { ChangeStatus } from "../../interfaces/api";
import {
  EntryCard,
  EntryCardDoneText,
  EntryCardHeading,
  EntryCardLinkText,
  EntryCardOpenText,
} from "./EntryCard";

export default function ErklaeringCard({
  erklaeringData,
  type,
  href,
  onClick,
}: {
  erklaeringData: {
    frist: string;
    status?: ChangeStatus;
    indsendt?: string;
    periodeFraDato?: string;
    periodeTilDato?: string;
    erklaeringAar?: string;
  };
  type: string;
  href?: string;
  onClick?: () => void;
}) {
  const { frist, status, indsendt } = erklaeringData;
  const body = (
    <EntryCard>
      <EntryCardHeading>
        {type}{" "}
        {erklaeringData.periodeFraDato !== undefined
          ? erklaeringData.periodeFraDato?.substring(0, 4)
          : erklaeringData.erklaeringAar !== undefined
            ? erklaeringData.erklaeringAar
            : ""}
      </EntryCardHeading>
      {status === "Indsendt" || status === "Synkroniseret" ? (
        <EntryCardDoneText>
          Indsendt{" "}
          {indsendt
            ? format(new Date(indsendt), "PPP", {
                locale: da,
              })
            : ""}
        </EntryCardDoneText>
      ) : (
        <EntryCardOpenText>
          {`Frist ${format(new Date(frist), "PPP", {
            locale: da,
          })}`}
        </EntryCardOpenText>
      )}
      {status === "Kladde" && (
        <EntryCardLinkText>Udfyld formular</EntryCardLinkText>
      )}
    </EntryCard>
  );

  if (status !== "Kladde") {
    return <div className="card card--muted">{body}</div>;
  }

  if (!href) {
    return (
      <Link to="" className="card" onClick={onClick}>
        {body}
      </Link>
    );
  }

  return (
    <Link to={href} className={`card`}>
      {body}
    </Link>
  );
}

export function ErklaeringCardDoneMaybe(props: {
  type: string;
  modtaget: string;
  href: string;
}) {
  const { href, type } = props;

  return (
    <Link className="card" to={href}>
      <EntryCard>
        <EntryCardHeading>
          {type.charAt(0).toUpperCase() + type.slice(1)}
        </EntryCardHeading>
        {/* Kun hvis der ligger en kladde:  */}
        <EntryCardOpenText>Frist ...</EntryCardOpenText>
        <EntryCardLinkText>Udfyld formular</EntryCardLinkText>
        {/* ellers:
        
        <EntryCardLinkText>Se mine indberetninger</EntryCardLinkText> */}
      </EntryCard>
    </Link>
  );
}
